import { ArrowUpRight } from "lucide-react";
import { ReactNode } from "react";

interface Props {
  title: string;
  description: string;
  link: string;
  icon?: ReactNode;
  features?: string[];
}

export default function EcosystemCard({
  title,
  description,
  link,
  icon,
  features = [],
}: Props) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="
        group block p-6 rounded-2xl transition-all duration-500
        bg-card
        border border-border
        shadow-lg hover:shadow-2xl
        transform hover:-translate-y-2
        relative overflow-hidden
        hover:border-primary/50
      "
    >
      {/* Gradient Border Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/5 to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

      <div className="relative z-10">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-xl bg-primary/10 text-primary">
              {icon}
            </div>
            <h2 className="text-xl font-bold text-primary">{title}</h2>
          </div>
          <ArrowUpRight className="w-5 h-5 text-text-secondary group-hover:text-primary transition-colors duration-300" />
        </div>

        <p className="text-text-secondary mb-4 leading-relaxed text-sm">
          {description}
        </p>

        {features.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-4">
            {features.map((feature, index) => (
              <span
                key={index}
                className="px-2 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full border border-primary/20"
              >
                {feature}
              </span>
            ))}
          </div>
        )}

        <div className="flex items-center text-primary font-semibold text-sm group-hover:gap-2 transition-all duration-300">
          <span>Explore Platform</span>
          <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
      </div>
    </a>
  );
}
